<template>
    <div class="fx fx-c_stretch ">
        <div class="fx-g1 edit_panel">
            <el-collapse >
                    <div v-html="agentInfo.content" style="text-align: center;margin-top: 5px;"></div>
            </el-collapse>
        </div>
    </div>
</template>

<style scoped>
    .funcs {
        width: 310px;
        background: white;
        box-sizing: border-box;
        padding: 15px;
    }

    .func_tree {
        width: 100%;
        margin-top: 15px;
    }

    .edit_panel {
        background: white;
        margin-left: 15px;
        padding: 60px;
    }

    .edit_form {
        width: 70%;
    }
    .custom-tree-node {
        padding: 2px 5px 0;
    }
    .custom-tree-node.active {
        background: #dadada;
    }
    .title_div {
        width:92%;
        padding-left: 25px;
        background-color:#ddd;
        height: 94%;
        margin-left: 5px;
        border-radius: 5px;
        font-size: 18px;
        color: inherit;
        font-weight:bold;
    }
</style>

<script>


    export default {
        components: {
        },
        props: [

        ],
        data() {
            return {
                agentInfo:[],
            }
        },

        computed: {
        },
        methods: {
            loadData() {
                this.$ajaxGet("/agentInfo/getInfoBySchool", (data) => {
                    this.agentInfo = data.result;
                })
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
